// Module 4: Regulatory Defensibility Assessment.
// Receives facts + QA + red flags. Produces 8-dimension defensibility verdict.

export function buildDefensibilityMessage({ facts, qaText, redFlagsText, fileName }) {
  return `Customer file under review: ${fileName || 'untitled'}

--- EXTRACTED FACTS (JSON) ---
${JSON.stringify(facts, null, 2)}

--- KYC QA ASSESSMENT ---
${qaText}

--- RED FLAGS ---
${redFlagsText}

--- END INPUTS ---

Now produce the 8-dimension defensibility assessment in the exact format specified in your instructions. Take the regulator's perspective: would the firm be able to defend the decisions made on this file?`;
}
